import { createSlice } from '@reduxjs/toolkit';

export interface ResultSubmissionStatus {
    ResultId: string;
    status: string;
}

interface ResultState {
    selectedResultIds: string[];
    props: any;
    sortByField: string,
    sortDirection: 'asc' | 'desc';
}

const initialState: ResultState = {
    selectedResultIds: [],
    props: {},
    sortByField: "created_at",
    sortDirection: 'desc'
};

export const resultSlice = createSlice({
    name: 'result',
    initialState,
    reducers: {
        setSortField: (state, action) => {
            state.sortByField = action.payload
        },
        setSortDirection: (state, action) => {
            state.sortDirection = action.payload
        },
        selectResultIds: (state, action) => {
            state.selectedResultIds = action.payload;
        },
        clearSelectedResultIds: (state) => {
            state.selectedResultIds = [];
        },
    },
});

export const { 
    setSortField,
    setSortDirection,
    selectResultIds,
    clearSelectedResultIds,
} = resultSlice.actions;

export const selectResultIdsState = (state: any) => state.result.selectedResultIds;
export const selectResultSortField = (state: any) => state.result.sortByField as string;
export const selectResultDirection = (state: any) => state.result.sortDirection as string;
export const selectResultsToBeSubmittedForAnalysis = (state: any) => state.result.ResultsToBeSubmittedForAnalysis;
export const selectResultSubmissionStatusList = (state: any) => state.result.ResultSubmissionStatusList;

export default resultSlice.reducer;
